import { useEffect, useState } from "react";
import { Box, Button, Typography, Snackbar } from "@mui/material";
import TermsandConditions from "../userAuth/Login/termsandconditions";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [openterms, setOpenterms] = useState(false);


  useEffect(() => {
    const handlePageLoad = () => {
      const isAccepted = localStorage.getItem("cookieConsent");
      if (!isAccepted) {
        // Slight delay (optional) for better UX
        setTimeout(() => setShowBanner(true), 3000);
      }
    };

    // Check if page already loaded (may happen in fast transitions)
    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
      return () => window.removeEventListener("load", handlePageLoad);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowBanner(false);
  };

  const handlecloseterms = () => {
    setOpenterms(false);
  };

  return (
    <Snackbar
      open={showBanner}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Box
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          p: 2,
          borderRadius: 2,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="body2">
          We use cookies to improve your experience. By using our site, you
          agree to our{" "}
          <span style={{ color: "#90caf9", textDecoration: "underline", cursor: "pointer" }} onClick={() => setOpenterms(true)}>
            Privacy Policy
          </span>
          .
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAccept}>
          Accept
        </Button>

          <TermsandConditions
            open={openterms}
            handleCloseTerms={handlecloseterms}
            title={"Privacy Policy"}
            type={"privacy"} // 🔹 Pass 'type' prop (required in API fetch)
          />
      

      </Box>
    </Snackbar>
  );
};

export default CookieConsent;
